import MenteesDashboard from './MenteesDashboard';

const DashboardContainer = () => {
  return <MenteesDashboard />;
};

export default DashboardContainer;
